module.exports = __webpack_public_path__ + "img/send-tx-right.0f2b4c5e.png";